var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { AvailablePopover } from '../../../../../components/other/AvailablePopover';
let MenuPartGrade = class MenuPartGrade extends React.PureComponent {
    render() {
        const { app } = this.props;
        return (React.createElement("div", { className: "MenuPartGrade", style: {
                flex: '1 1 auto',
                marginLeft: 10,
                marginRight: 10
            } },
            React.createElement("h3", { className: "text-danger", style: { marginTop: 0, marginBottom: 0, paddingTop: '46.5px' } },
                "Note:\u00A0",
                React.createElement(AvailablePopover, { content: `Note der letzten ${app.appGrade.numberOfAnswersGradeIsBasedOn} Antworten`, trigger: "hover", placement: "bottom" },
                    React.createElement("span", null, app.appGrade.currentGradeString)))));
    }
};
MenuPartGrade = __decorate([
    observer
], MenuPartGrade);
export { MenuPartGrade };
